import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

// import JS files
import PanelTable from "../../../shares/PanelTable";
import useFetch from "../../../../context/useFetch";
import {
  fixNumbers,
  // ringTableItems,
  // ringTableItemsDataKey,
} from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useSetting } from "../../../../context/SettingContext";

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
];

const ringHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  // { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "code_one", name: "تعداد یک" },
  { colName: "code_two", name: "تعداد دو" },
  { colName: "code_three", name: "تعداد سه" },
  { colName: "code_four", name: "تعداد چهار" },
  { colName: "code_five", name: "تعداد پنج" },
  // { colName: "details", name: "جزییات" },
];

const ringDataKey = [
  "code",
  "show_name",
  "gender",
  "color",
  // "created_at",
  "size_one_num",
  "size_two_num",
  "size_three_num",
  "size_four_num",
  "size_five_num",
];

const StockTable = () => {
  const [codeFilter, setCodeFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const { ringTableItems, ringTableItemsDataKey } = useSetting();

  const update_filter = (state, e) => {
    if (state == "brand") setBrandFilter(e);
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setBrandFilter(null);
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };

  const buttonsList = [
    // {
    //   label: "مشاهده جزییات",
    //   component: (it) => (
    //     <OrderDetails selectedRow={it} getRequestListApi={getRequestListApi} />
    //   ),
    // },
  ];

  const actionsList = [];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 350,
    count: 0,
  });

  const [requestList, setRequestList] = useState({ results: [] });

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      brand: brandFilter,
      code: fixNumbers(codeFilter),
      show_changed: true,
    },
    url: "BangleStock_Service/get_stocks",
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });

  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",

    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];

  return (
    <>
      <PanelTemplate sidebarActiveLink="stocks-table">
        <>
          <div className="panel-main-header">
            <span>موجودی سفارش تولیدکننده</span>
          </div>
          <PanelFilter
            header="فیلتر :"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <PanelTable
            header="لیست النگوهای قابل ثبت سفارش:"
            headers={ringHeadersList}
            dataKey={ringDataKey}
            mobileHeaders={mobileHeadersList}
            data={requestList.results}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AddShoppingCartIcon />}
            // setSelectedRow={setSelectedRow}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default StockTable;
